<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/AuthStore'
import { email } from '@/utilities/validators'

export default {
  setup() {
    return {
      authStore: useAuthStore(),
      v$: useVuelidate(),
    }
  },
  data() {
    return {
      email: '',
      errors: {},
      submitted: false,
    }
  },
  validations() {
    return {
      email: {
        email: helpers.withMessage('Please enter a valid email.', email),
        required: helpers.withMessage('Email is required.', required),
      },
    }
  },
  watch: {
    'v$.$errors': {
      handler(value) {
        /**
         * If a new front end validation error comes in, clear the previous server side errors to
         * avoid collisions.
         */
        if (value)
          this.errors = {}
      },
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch()
      if (!this.v$.$invalid) {
        this.submitted = true
        const formData = {
          email: this.email,
        }
        this.authStore.resendActivationEmail(formData)
          .then(() => {
            this.authStore.accountActivated = null
            this.$router.replace({ name: 'verify-account' })
          },
          (error) => {
            this.authStore.accountActivated = null
            this.errors = error.data || { email: ['There was an error sending a new confirmation email.'] }
            this.submitted = false
          })
      }
    },
  },
}
</script>

<template>
  <div class="full-wh-page">
    <div class="form-based-page">
      <div class="user-form">
        <template v-if="authStore.accountActivated === false">
          <div class="user-form__head">
            <h1>Oops</h1>
            <p>We had an issue activating your account. Please enter your email address below to have us resend you a new account verification email.</p>
          </div>
        </template>
        <template v-else>
          <div class="user-form__head">
            <h1>Ahem, pardon me, good citizen.</h1>
            <p>Looks like you need us to resend the confirmation email. No problem. Let's get you reading lickety split.</p>
          </div>
        </template>
        <div class="user-form__alerts">
          <p v-if="v$.$errors.length" class="user-form__alerts__error-msg">
            Please correct the following errors:
          </p>
        </div>
        <div class="user-form__body">
          <form @submit.prevent="onSubmit">
            <div class="user-form__input-wrap">
              <BaseInput
                v-model.trim="email"
                type="text"
                placeholder="Email"
                :class="{ error: v$.email.$error }"
                @blur="v$.email.$touch()"
              />
              <template v-if="v$.email.$error">
                <p
                  v-for="error in v$.email.$errors"
                  :key="error.$uid"
                  class="form-error-msg--absolute"
                >
                  {{ error.$message }}
                </p>
              </template>
              <div v-if="errors.email" class="form-error-msg">
                <p v-for="(error, index) in errors.email" :key="index">
                  {{ error }}
                </p>
              </div>
            </div>
            <BaseButton
              class="user-form__submit-btn"
              button-size="large"
              button-type="primary"
              type="submit"
              :disabled="v$.$errors.length || submitted"
            >
              Submit
            </BaseButton>
          </form>
          <p>
            Already verified your account? <router-link :to="{ name: 'signin' }">
              Sign In
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
